/**
 * The media state is persisted with a scene, but the video's running clock is
 * intentionally local to each display. A scene clone caused by an unrelated
 * edit must not be mistaken for a request to seek that local clock.
 */
export interface AppliedVideoPlaybackCommand {
  source: string | undefined;
  commandTimestamp: number;
}

export type VideoPlaybackState = {
  playing: boolean;
  currentTime: number;
  commandTimestamp: number;
};

/** Resolve a shared video command to the wall-clock position for this display. */
export function videoPlaybackTime(media: VideoPlaybackState, now = Date.now()): number {
  if (!media.playing) return media.currentTime;
  return Math.max(0, media.currentTime + Math.max(0, now - media.commandTimestamp) / 1_000);
}

/**
 * A seek is only required for a newly mounted/source video or an explicit DM
 * media command. In particular, a token move preserves the same command time.
 */
export function shouldSynchronizeVideoTime(
  applied: AppliedVideoPlaybackCommand | undefined,
  source: string | undefined,
  commandTimestamp: number,
): boolean {
  return !applied || applied.source !== source || applied.commandTimestamp !== commandTimestamp;
}
